<template>
  <symbol id="pin-person" viewBox="0 0 58.69 66.42">
    <path d="M58.69,29.35A29.35,29.35,0,0,0,29.64,0,29.66,29.66,0,0,0,0,29.13,29.34,29.34,0,0,0,19,56.8a14.91,14.91,0,0,1,5.64,3.85,59.73,59.73,0,0,1,4.23,5.49.67.67,0,0,0,1.06,0c1.65-2,3.34-4.21,5.07-6a15,15,0,0,1,5.24-3.57A29.33,29.33,0,0,0,58.69,29.35Z" />
    <circle cx="29.35" cy="29.53" r="23.24" fill="#fff"/>
    <circle cx="29.35" cy="18.74" r="8.98" />
    <path d="M29.35,28.53h0A15.33,15.33,0,0,1,44.67,43.85v9.32a0,0,0,0,1,0,0H14a0,0,0,0,1,0,0V43.85A15.33,15.33,0,0,1,29.35,28.53Z" />
  </symbol>
</template>

<script>
export default {
}
</script>



// WEBPACK FOOTER //
// person_pin.vue?3eb09e74